import DynamicSectionElement from '@/scripts/dynamic-section-element.js'

class StickyBar extends DynamicSectionElement {
  constructor() {
    super();

    this.el = this

    const ANCHOR_LINK_SELECTOR = '.js-anchor-link'
    const ACTIVE_CLASS = 'active'

    window.addEventListener('scroll', () => {
      const anchorLinks = Array.prototype.slice.call(document.querySelectorAll(ANCHOR_LINK_SELECTOR))
      let lastPosition = 0

      if (anchorLinks.length) {
        anchorLinks.forEach(anchor => {
          const selector = anchor.getAttribute("href")

          if (!selector) return
          const anchorEl = document.querySelector(selector)
          if (anchorEl) {
            const rect = anchorEl.getBoundingClientRect()
            const top = rect.top
            const bottom = rect.bottom
            const offsetTop = anchorEl.offsetTop + anchor.offsetHeight
            if (lastPosition < offsetTop) {
              lastPosition = offsetTop
            }
            const navHeight = this.el.clientHeight

            if ((top < navHeight && bottom >= navHeight )) {
              if (!anchor.classList.contains(ACTIVE_CLASS)) {
                anchor.classList.add(ACTIVE_CLASS)

                this.scrollLeft = anchor.offSetLeft
              }
            } else {
              if (anchor.classList.contains(ACTIVE_CLASS)) {
                anchor.classList.remove(ACTIVE_CLASS)
              }
            }
          }
        })
      }
    })
  }
  scrollToBlock(event,id) {
    event.preventDefault();

    const el = document.querySelector(id)
    if (el) {
      const navHeight = this.el.offsetHeight
      let y = el.getBoundingClientRect().top + window.pageYOffset - navHeight + 2;

      window.scrollTo({top: y, behavior: 'smooth'});
    }
  }

}

customElements.define('sticky-bar', StickyBar)
